import { ShopperAgentChannelKind } from "@redotech/cockroachdb-codegen/tables/shopper-ai/shopper-agent-channel-kind";
import * as z from "zod";

export const ShopperAgentMessageChannelKinds = [
  ShopperAgentChannelKind.Sms,
  ShopperAgentChannelKind.Email,
] as const;
export type ShopperAgentMessageChannelKind =
  (typeof ShopperAgentMessageChannelKinds)[number];
export const ShopperAgentMessageChannelKind = ShopperAgentMessageChannelKinds;

const shopperAgentMessageSmsChannelSchema_ = z.object({
  kind: z.literal(ShopperAgentChannelKind.Sms),
  extendedOutreach: z.boolean().optional(),
});
export interface ShopperAgentMessageSmsChannel extends z.infer<
  typeof shopperAgentMessageSmsChannelSchema_
> {}

const shopperAgentMessageEmailChannelSchema_ = z.object({
  kind: z.literal(ShopperAgentChannelKind.Email),
  extendedOutreach: z.undefined().optional(),
});
export interface ShopperAgentMessageEmailChannel extends z.infer<
  typeof shopperAgentMessageEmailChannelSchema_
> {}

export const shopperAgentMessageChannelSchema = z.discriminatedUnion("kind", [
  shopperAgentMessageSmsChannelSchema_,
  shopperAgentMessageEmailChannelSchema_,
]);
export type ShopperAgentMessageChannel = z.infer<
  typeof shopperAgentMessageChannelSchema
>;
